import type { TbHttp } from "./http";
import type { EntityRef, PageData, TbEntity } from "./types";

function qs(opts: { pageSize?: number; page?: number; textSearch?: string; type?: string }) {
  const p = new URLSearchParams({
    pageSize: String(opts.pageSize ?? 100),
    page: String(opts.page ?? 0),
    sortProperty: "createdTime",
    sortOrder: "DESC",
  });
  if (opts.textSearch) p.set("textSearch", opts.textSearch);
  if (opts.type) p.set("type", opts.type);
  return p.toString();
}

export function listTenantAssets(http: TbHttp, opts: Parameters<typeof qs>[0] = {}) {
  return http.get<PageData<TbEntity>>(`/api/tenant/assets?${qs(opts)}`);
}
export function listTenantDevices(http: TbHttp, opts: Parameters<typeof qs>[0] = {}) {
  return http.get<PageData<TbEntity>>(`/api/tenant/devices?${qs(opts)}`);
}

export function getEntityInfo(http: TbHttp, entity: EntityRef): Promise<TbEntity> {
  switch (entity.type) {
    case "ASSET":   return http.get(`/api/asset/${entity.id}`);
    case "DEVICE":  return http.get(`/api/device/${entity.id}`);
    case "CUSTOMER":return http.get(`/api/customer/${entity.id}`);
    default: return Promise.reject(new Error(`Unsupported entity type "${entity.type}"`));
  }
}

export function getCurrentUser(http: TbHttp): Promise<{
  id: { id: string };
  tenantId?: { id: string };
  customerId?: { id: string };
  email: string;
  authority: string;
  firstName?: string;
  lastName?: string;
  additionalInfo?: Record<string, unknown> | null;
}> {
  return http.get(`/api/auth/user`);
}
